// extracted by mini-css-extract-plugin
export default {"handle":"_tB82L","children":"rLbGv9","level-0":"RfUOJz","level-1":"y11wxw"};